/**
 * Simula parcela mensal sugerida para atingir um objetivo no prazo.
 * @param {{ valorObjetivo: number|null, prazoMeses: number|null }} values
 * @returns {{ valorObjetivo: number, prazoMeses: number, parcelaMensal: number }|null}
 */
export function simularQuantoGuardar({ valorObjetivo, prazoMeses }) {
    const valor = Number(valorObjetivo);
    const prazo = Number(prazoMeses);
    if (!Number.isFinite(valor) || valor <= 0) return null;
    if (!Number.isFinite(prazo) || prazo < 1) return null;

    const parcelaMensal = Math.ceil(valor / prazo);
    return {
        valorObjetivo: valor,
        prazoMeses: Math.floor(prazo),
        parcelaMensal,
    };
}
